export const headers = [ 0.62, 0.05, 0.01, 0.98 ]
export const articles = headers
export const products = articles
export const parallax = 8
